import allOffers from 'components/all-offers';
import offerStrip from 'components/offers/offers-strip';
import offerDetail from 'components/offers/offer-detail-ajax';
import addInv from 'components/offers/offer.additional.inv';
import favorites from 'features/favorites';

export default {
  allOffers: allOffers,
  offerStrip: offerStrip,
  offerDetail: offerDetail,
  addInv: addInv,
  favorites: favorites
};
